import React from "react";
import { render } from "react-dom";
import ReactGA from "react-ga";
import { AppContainer } from "react-hot-loader";
import { browserHistory } from "react-router";
import Relay from "react-relay/classic";
import Root from "./Root";
import { GOOGLE_ANALYTICS_TRACKING_ID } from "config";
import * as routerUtils from "components/helpers/routerUtils";
import { MuiThemeProvider } from "@material-ui/core";
import theme from "./components/helpers/theme";

routerUtils.convertToNonHash();
ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
browserHistory.listen(() => {
  const p =
    window.location.pathname + window.location.search + window.location.hash;
  ReactGA.pageview(p);
  ReactGA.set({ page: p });
});
Relay.injectNetworkLayer(
  new Relay.DefaultNetworkLayer(
    `${process.env.API_URL}/graphql?silo_id=${process.env.SILO_ID}`,
    {
      mode: "cors",
      credentials: "include",
    }
  )
);

const root = document.getElementById("root");

render(
  <AppContainer>
    <MuiThemeProvider theme={theme}>
      <Root />
    </MuiThemeProvider>
  </AppContainer>,
  root
);

if (module.hot) {
  module.hot.accept("./Root", () => {
    const NewRoot = require("./Root").default;
    render(
      <AppContainer>
        <NewRoot />
      </AppContainer>,
      root
    );
  });
}



// WEBPACK FOOTER //
// ./js/app.js